import { render } from "./PendingDestructionModal.vue?vue&type=template&id=16297a53"
import script from "./PendingDestructionModal.vue?vue&type=script&lang=js"
export * from "./PendingDestructionModal.vue?vue&type=script&lang=js"

import "./PendingDestructionModal.vue?vue&type=style&index=0&id=16297a53&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__